import React from 'react';

// eslint-disable-next-line import/prefer-default-export
export const ReportDateContext = React.createContext<{ reportDate: Date; settlementDate: Date }>({
  reportDate: new Date(),
  settlementDate: new Date(),
});
